module.exports = __webpack_public_path__ + "static/media/receivables.406e314f.svg";